/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Code_LabelInputs */

const en_delete_account_code_label = /** @type {(inputs: Delete_Account_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const es_delete_account_code_label = /** @type {(inputs: Delete_Account_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código`)
};

const ar_delete_account_code_label = /** @type {(inputs: Delete_Account_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرمز`)
};

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Delete_Account_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_code_label = /** @type {((inputs?: Delete_Account_Code_LabelInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Code_LabelInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_code_label(inputs)
	if (locale === "es") return es_delete_account_code_label(inputs)
	return ar_delete_account_code_label(inputs)
});